<template>
  <div>
    <v-card flat class="rounded-lg mt-5 textLight--text">
      <v-row>
        <v-col cols="2">
          <div class="font-weight-light ps-5">
            <v-row>
              <v-col cols="3" class="px-0">
                <v-img
                  class="rounded-lg"
                  max-height="40"
                  eager
                  max-width="40"
                  :src="
                    revenueData.images && revenueData.images.length
                      ? getImage(revenueData.images)
                      : require('@/app/core-module/assets/images/logo_placeholder.png')
                  "
                  contain
                />
              </v-col>
              <v-col cols="9" class="px-0">
                <div class="ms-3 align-center" style="text-align: start">
                  <div class="text--left subtitle-1">
                    <span>
                      {{
                        revenueData.title && revenueData.title.length
                          ? getLocalisedValue(revenueData.title)
                          : "-"
                      }}
                    </span>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="2">
          <div class="text-start">
            {{
              revenueData.organization && revenueData.organization.name
                ? getLocalisedValue(revenueData.organization.name)
                : "-"
            }}
          </div>
        </v-col>
        <v-col cols="2">
          <div class="text-ellipse-1 text-center">0</div>
        </v-col>

        <v-col cols="2">
          <div class="text-ellipse-1 text-center">0</div>
        </v-col>

        <v-col cols="2">
          <div class="text-ellipse-1 text-center">0</div>
        </v-col>
        <v-col cols="2">
          <div class="text-ellipse-1 text-center">0</div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
export default {
  props: {
    revenueData: {
      type: Object,
      required: true,
    },
  },
};
</script>
